import { render } from "./NavbarSection.vue?vue&type=template&id=a670e6ee&scoped=true"
import script from "./NavbarSection.vue?vue&type=script&lang=js"
export * from "./NavbarSection.vue?vue&type=script&lang=js"

import "./NavbarSection.vue?vue&type=style&index=0&id=a670e6ee&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a670e6ee"]])

export default __exports__